module.exports = __webpack_public_path__ + "img/artillery-wagon-base-7.d6e6a9a4.png";